import * as React from "react";
import * as React44ms from "../../Util/form-utils/react-44ms";

import {
  ACountry,
  ManualAddressExpects,
  SelectWithDropdownInput2023,
  SelectWithDropdownInput_Option,
  SingleLineTextInput2023,
  useDataSourceCheckoutRegionsQuery,
} from "../../Common";

export interface ManualAddressFormFragmentProps {
  formRef: React44ms.Api.TypedRef<ManualAddressExpects>;
  addressFormType: string;
  handleGoBackToAddressLookup: React.MouseEventHandler<HTMLAnchorElement>;
  countryOptions: (SelectWithDropdownInput_Option & {
    presentableLabelForRestriction: string;
  })[];
  restrictionAdditionsIfNecessary: string;
}
export const ManualAddressFormFragment: React.FunctionComponent<
  ManualAddressFormFragmentProps
> = (props) => {
  const { data: checkoutRegionsData } = useDataSourceCheckoutRegionsQuery();

  const [_formState, locate] = React44ms.React.useForm(props.formRef);

  const stateOptions: SelectWithDropdownInput_Option[] = React.useMemo(
    () =>
      (checkoutRegionsData?.available_regions || []).map((region) => ({
        id: region.code,
        presentableLabel: region.name,
      })),
    [checkoutRegionsData]
  );

  return (
    <React.Fragment>
      <a
        href="javascript:void(0)"
        onClick={props.handleGoBackToAddressLookup}
        className="go-back-to-address-lookup"
      >{`Go back to address lookup`}</a>

      <SingleLineTextInput2023
        title={`Street Address ${props.restrictionAdditionsIfNecessary}`}
        formRef={locate.addressLine1.typedRef}
        charLength={32}
      >
        <SingleLineTextInput2023 formRef={locate.addressLine2.typedRef} charLength={32} />
      </SingleLineTextInput2023>

      <SingleLineTextInput2023
        title={`Suburb ${props.restrictionAdditionsIfNecessary}`}
        formRef={locate.suburb.typedRef} charLength={32}
      />

      <section className="code-and-state">
        <SingleLineTextInput2023
          title={`ZIP/Postal Code ${props.restrictionAdditionsIfNecessary}`}
          formRef={locate.postcode.typedRef} charLength={4} type='number'
        />
        {stateOptions && stateOptions.length > 0 ?
          (<SelectWithDropdownInput2023
          title={`State ${props.restrictionAdditionsIfNecessary}`}
          placeholder={`Select a state ${props.restrictionAdditionsIfNecessary}`}
          formRef={locate.state.typedRef}
          options={stateOptions}
        />) : (
          <SingleLineTextInput2023
            title={`City ${props.restrictionAdditionsIfNecessary}`}
            formRef={locate.state.typedRef}
            charLength={32}
          />
        )}
      </section>

      <SelectWithDropdownInput2023
        title={`Country ${props.restrictionAdditionsIfNecessary}`}
        placeholder={`Select a country ${props.restrictionAdditionsIfNecessary}`}
        options={props.countryOptions}
        formRef={locate.country.typedRef}
      />
    </React.Fragment>
  );
};
